import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    minHeight: { type: Number, default: 60 },
    maxHeight: { type: Number, default: 500 }
  }

  connect() {
    this.element.style.resize = 'none';
    this.element.style.overflow = 'hidden';
    this.resize();
  }

  resize() {
    this.element.style.height = 'auto';

    const newHeight = Math.min(
      Math.max(this.element.scrollHeight, this.minHeightValue),
      this.maxHeightValue
    );
    this.element.style.height = `${newHeight}px`;
  }
}
